<!--
 * @Author: your name
 * @Date: 2021-04-14 14:42:03
 * @LastEditTime: 2021-04-16 09:40:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/views/user/receipt/Affirm.vue
-->

<template>
  <Nav-bar
    :has_back="true"
    :has_right="false"
    title="开具发票申请确认"
  ></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <div class="item-v display_flex">
      <span class="t-f14-c66">公司全称</span>
      <span class="t-f14-c1a c-t">{{ affirmData.titleInfo.title }}</span>
    </div>
    <div class="item-v display_flex">
      <span class="t-f14-c66">发票内容</span>
      <span class="t-f14-c1a c-t">充电服务费</span>
    </div>
    <div class="item-v display_flex">
      <span class="t-f14-c66">发票金额</span>
      <span class="t-f14-cf19321 c-t"
        >{{ affirmData.invoicesTotalNumber.toFixed(2) }} 元</span
      >
    </div>
    <div class="item-v display_flex">
      <span class="t-f14-c66">发票类型</span>
      <span class="t-f14-c1a c-t"
        >{{
          affirmData.titleInfo.title_genre == "company" ? "企业" : "个人"
        }}电子发票</span
      >
    </div>
    <div
      class="item-v display_flex"
      v-if="affirmData.titleInfo.tax_registration_number != ''"
    >
      <span class="t-f14-c66">纳税人识别号</span>
      <span class="t-f14-c1a c-t">{{
        affirmData.titleInfo.tax_registration_number
      }}</span>
    </div>
    <div class="item-v display_flex" style="border: none" @click="toInclude">
      <span class="t-f14-c66">所含内容</span>
      <span class="t-f14-cf19321 c-t"
        >{{ affirmData.invoicesList.length }} 个订单</span
      >
      <img src="@/images/arrows.png" class="r-i arrows-icon" />
    </div>
  </div>
  <div class="item-v display_flex m-t-10 email-v" style="border: none">
    <span class="t-f14-c66">电子邮件</span>
    <div class="c-t">
      <van-field
        v-model="emailValue"
        placeholder="请填写您的邮箱"
        :error="emailValue == ''"
      />
    </div>
  </div>
  <div class="tip t-f12-c99">
    请确认邮箱无误，电子发票将在开票后发送至您的邮箱；如没收
    到邮件，请稍后五分钟或查看邮箱的垃圾箱。
  </div>
  <div class="m-20">
    <van-button type="primary" size="normal" class="main-btn" @click="toSuccess"
      >确认提交</van-button
    >
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import request from "@/api/request";
import { ref } from "vue";
import { Toast } from 'vant';
let router;
let storeContext;
let that;
let emailValue = ref("")

export default {
  components: {
    NavBar,
  },
  setup() {
    router = useRouter();
    storeContext = useStore();
    const affirmData = storeContext.state.invoicesData;
    return { toInclude, toSuccess,emailValue, affirmData };
  },
  created() {
    that = this;
  },
  methods: {
    //formate the invoices data for get id  array
    formatOrderId() {
      let invoicesList = storeContext.state.invoicesData.invoicesList;
      let idContainer = [];
      for (let index = 0; index < invoicesList.length; index++) {
        const param = invoicesList[index];
        idContainer.push(param.id);
      }
      return idContainer;
    },
    applyInvoices() {
      let params = {};

      params["order_ids"] = that.formatOrderId();
      params["invoice_document_type"] = "electronic";
       params["email"] = emailValue.value;
      params["user_invoice_id"] = storeContext.state.invoicesData.titleInfo.id;
      request.postUserInvoices(params).then(() => {
        router.replace("/user/receipt/success");
      });
    },
  },
};
function ischeckemail(email) {
  if (email != "") {
    var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
    //调用正则验证test()函数
    let isok = reg.test(email);
    if (!isok) {
      Toast("邮箱格式不正确，请重新输入！");
      return false;
    }
    return true;
  }
}
function toSuccess() {
  if(emailValue.value == ''){
    return
  }
  if(!ischeckemail(emailValue.value)){
    Toast("请检查邮箱格式")
    return
  }
  //开票
  that.applyInvoices();
}
//包含订单列表
function toInclude() {
  router.push("/user/receipt/include_list");
}
</script>
<style scoped>
.email-v {
  background: #fff;
  margin: 10px;
  border-radius: 5px;
  padding: 0 10px;
}
.tip {
  margin: 15px 20px;
}
.r-i {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.item-v {
  border-bottom: 1px #ebebeb solid;
  position: relative;
  line-height: 44px;
}
.c-t {
  position: absolute;
  left: 115px;
  top: 50%;
  transform: translateY(-50%);
}
.container {
  background: #fff;
  padding: 0px 10px;
  margin: 10px;
  border-radius: 5px;
}
</style>